import { ClearCacheButton } from 'spa/components/clear_cache'
import { FormattedMessage } from 'react-intl'
import { Heading } from '../typography'
import { Layout } from 'spa/components/layout'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import styles from './styles'

function ErrorMessage({ history, resetErrorBoundary }) {
  useEffect(() => {
    let unlisten
    if (typeof history?.listen === 'function') {
      unlisten = history.listen(resetErrorBoundary)
    }

    return unlisten
  }, [history, resetErrorBoundary])

  return (
    <Layout tabTitle="error">
      <div className={styles.container}>
        <Heading className={styles.heading}>
          <FormattedMessage
            defaultMessage="Whoops, something went wrong."
            id="djcity.common.error"
          />
        </Heading>
        <ClearCacheButton />
      </div>
    </Layout>
  )
}

ErrorMessage.propTypes = {
  history: PropTypes.shape({ listen: PropTypes.func }).isRequired,
  resetErrorBoundary: PropTypes.func.isRequired,
}

const ConnectedErrorMessage = withRouter(ErrorMessage)

export { ConnectedErrorMessage as ErrorMessage }
